import React, { useState, useEffect, Fragment, useRef, useMemo } from "react";
import ReactDOM from "react-dom";
import useRequireAuth from "../../utils/useRequireAuth";
import {
  useFetchCustomerUseListDataQuery,
  useFetchCommonDataQuery,
  useLazyFetchLinkedSectionsFieldsQuery,
  useLazyFetchFieldValuesQuery,
  useFetchAllTemplateQuery,
} from "../../utils/customer/customerSelect";
import DatePicker from "react-datepicker";
// import {useFetchTaskGetOrgAccordingQuery} from "../../utils/customer/customerTaskTable"
import { FaArrowRight } from "react-icons/fa6";
import "react-datepicker/dist/react-datepicker.css";
import { saveTasks, hideMessage } from "../../utils/customer/customerTaskSlice";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import OwnerDropDown from "../GlobalFeature/Fields/OwnerDropDown";
import { useLazyFetchPersonInTableQuery, useLazyFetchRandomUserQuery } from "../../utils/customer/customerTable";
import { useFetchCustomerAllTaskPodDataQuery } from "../../utils/customer/customerSelect";
import useCustomFormValidation from "../../hooks/ErrorHandling/useCustomFormValidation";
import { createPortal } from "react-dom";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Checkbox,
  FormControlLabel,
  Tooltip,
  Box,
  Autocomplete,
  Dialog,
  Modal,
  Fade,
  Backdrop,
  Drawer,
} from "@mui/material";
import { CUSTOMER_EDIT_TASK_DATA, NODE_URL } from "../../utils/constants";
import useDebounce from "../GlobalFeature/useDebounce";
import { getCommonDataBasedOnId } from "../store/customer/CustomerSocialAddUpdateFunction";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

import dayjs from "dayjs";
import CreatePortalHOC from "../GlobalFeature/Fields/CreatePortalHOC";
import TaskFormValidation from "../../hooks/ErrorHandling/TaskFormValidation";
import CustomerEditTaskActivity from "../customer/CustomerEditTaskActivity";
import RecurrenceModal from "../customer/RecurrenceModal";
import { ReactComponent as CalendarIcon } from "../../assets/images/calendarIcon.svg";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { ReactComponent as AddIconOnProfile } from "../../assets/images/addIconOnProfile.svg";
import { ReactComponent as HandleNotificationexpandshyrink } from "../../assets/images/handleNotificationexpandshyrink.svg";
import { ReactComponent as AddProfileWithCircle } from "../../assets/images/addProfileWithCircle.svg";
import { ReactComponent as CrossIconAddTaskPodModal } from "../../assets/images/crossIconAddTaskPodModal.svg";
import { ReactComponent as AddTaskCrosIcn } from "../../assets/images/addTaskCrosIcn.svg";
import { ReactComponent as RecurtionIcn } from "../../assets/images/recurtionIcn.svg";
import { ReactComponent as CalendarRefreshIcon } from "../../assets/images/calendarRefreshIcon.svg";
import { ReactComponent as TimerImg } from "../../assets/images/icons/TimerImg.svg";
import { ReactComponent as BackIcon } from "../../assets/images/icons/BackIcon.svg";
import {
  useCreateJobMutation,
  useCreateUpdateProjectMutation,
  useFetchAllTaskPodsQuery,
  useFetchCustomerTaskPodAllCustomerDataQuery,
  useLazyFetchAllProjectsQuery,
  useLazyFetchServiceListQuery,
  useLazyGetProjectTaskEnumQuery,
  useLazyGetTaskTagsQuery,
  usePostApiMutation,
  usePostTaskTagsMutation,
} from "../../utils/customer/customerTaskTable";
import { ReactComponent as CalendarWithTimeIcon } from "../../assets/images/calendarWithTimeIcon.svg";
import { ReactComponent as LinkIcon } from "../../assets/images/linkIcon.svg";
import { ReactComponent as LocationPinIcon } from "../../assets/images/locationPinIcon.svg";
import { ReactComponent as FedCrossIMG } from "../../assets/images/fedCrossIMG.svg";
import { ReactComponent as AddSubTaskDownArrow } from "../../assets/images/addSubTaskDownArrow.svg";
import { ReactComponent as GreenPlusIcon } from "../../assets/images/greenPlusIcon.svg";
import { ReactComponent as RedDeleteIcon } from "../../assets/images/redDeleteIcon.svg";
import { ReactComponent as DownAngleBracket } from "../../assets/images/downAngleBracket.svg";
import { ReactComponent as DeleteSubTaskIcon } from "../../assets/images/deleteSubTaskIcon.svg";
import { ReactComponent as MenuBar } from "../../assets/images/icons/SideMenu.svg";
import { ReactComponent as NextPage } from "../../assets/images/icons/NextPage.svg";
import { ReactComponent as ReloadIcon } from "../../assets/images/icons/ReloadIcon.svg";
import { ReactComponent as Share } from "../../assets/images/Share.svg";
import { ReactComponent as PlusIcon } from "../../assets/images/icons/PlusIcongrey.svg";
import FirstMessage from "../GlobalFeature/MessageAlert/FirstMessage";
import { pushAlert } from "../../utils/alertSlice";
import { SubTaskDrawer } from "./SubTaskDrawer";
import { ChecklistDrawer } from "../TaskPod/ChecklistDrawer";
import FloatingList from "../UniversalComponents/FloatingElement";
import FieldElements from "../UniversalComponents/FieldElements";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import CustomAccordion from "../UniversalComponents/CustomAccordion";
import ConfirmationDialogBox from "../UniversalComponents/ConfirmationDialogBox";
import { Category } from "@mui/icons-material";
import AddNewPodModal from "./AddNewPodModal";
import DelegationSelection from "./DelegationSelection";
import ViewDelegation from "../TaskPod/ViewDelegation";
import AddViewProjectDrawer from "../TaskPod/AddViewProjectDrawer";
import expandButton from "../../assets/images/ExpandButton.svg";
import { getFormData, getSentenceCase } from "../../utils/utilityFunctions/stringUtility";
import ProjectDetails from "../TaskPod/ProjectDetails";
import DateTimeCombo from "./DateTimeCombo"; // once its remove and make the copy as DateTimeRecurence
import moment from "moment";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import LinkedDrawer from "../TaskPod/LinkedDrawer";
import { useNoOpLazyQuery } from "../TaskPod/useNoOpLazyQuery";
import JobSummary from "../TaskPod/JobSummary";
import { getDatePlusOne } from "../../utils/utilityFunctions/dateUtility";
import DelegationMultiSelect from "./DelegationMultiSelect";
import LabelComponent from "../UniversalComponents/LabelComponent";
import SubDrawerRenderer from "../UniversalComponents/SubDrawerRenderer";
import FunnelSubDrawer from "./FunnelSubDrawer";
import { useFetchFunnelStagesQuery, useLazyFetchFunnelTypeQuery } from "../../utils/customer/funnelSlice";
import SelectComponent from "../UniversalComponents/SelectComponent";
import DateTimeRecurence from "./DateTimeRecurence";
const leadTypeList = ["task", "project"];
const formDisabledStatuses = ["Completed", "Drop", "Cancelled"];

let tags_data = [
  { tag_name: "tag1", colour: "#FF5733" },
  { tag_name: "tag2", colour: "#33FF57" },
  { tag_name: "tag3", colour: "#3357FF" },
  { tag_name: "tag4", colour: "#F3F33F" },
  { tag_name: "tag5", colour: "#FF33A1" },
  { tag_name: "tag6", colour: "#A1FF33" },
  { tag_name: "tag7", colour: "#33A1FF" },
  { tag_name: "tag8", colour: "#FFB533" },
  { tag_name: "tag9", colour: "#33FFB5" },
  { tag_name: "tag10", colour: "#B533FF" },
];
let selected_tags = [];

// const formatDate = (date) => {
//   if (!date) return '';
//   const d = new Date(date);
//   const formattedDate = `${d.getDate().toString().padStart(2, '0')}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getFullYear()}`;
//   return formattedDate;
// };

const roundUpToNearest30Minutes = (date) => {
  const minutes = date.getMinutes();
  const nextInterval = Math.ceil(minutes / 30) * 30;
  date.setMinutes(nextInterval);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
};

const addMinutes = (date, minutes) => {
  const newDate = new Date(date);
  newDate.setMinutes(newDate.getMinutes() + minutes);
  return newDate;
};

// Helper function to check if two dates are on the same day
const isSameDay = (date1, date2) => {
  return date1.toDateString() === date2.toDateString();
};

const colorPool = ["#37C015", "#BE4A25", "#401E87", "#6417D8", "#F16136"];

const TaskExtendView = ({
  isOpen,
  closePopup,
  taskid,
  viewFor,
  leadTypeValue,
  disableLeadTypeChange,
  onClose,
  selectedCustomer,
  checkListOpen,
  setCheckListOpen,
  customerTask,
  customerData,
  setLeadTypeValue = () => {},
  openSubTaskDrawer,
  // isDoubleComp = false,
  recurModal,
  activeModal,
  templateId,
  setTemplateId,
  propTemplateId,
  refetchGetAllTasks = () => {},
  isMyActivity = false,
  externalApi = false,
}) => {
  const token = useRequireAuth();

  const completeAuth = useRequireAuth();

  const { id: customerId } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const companyLocalData = localStorage.getItem("company_data");
  const userData = localStorage.getItem("myUserData");
  const userId = JSON.parse(userData).user_id;

  const parsedCompanyData = JSON.parse(companyLocalData);
  const [customerTablePagination, setCustomerTablePagination] = useState("");
  const [activeTab, setActiveTab] = useState("#All");
  const [quiFilter, setQuiFilter] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  //const[taskOpenTab,getTaskOpenTab]=useState(1)

  const [refreshKey, setRefreshKey] = useState(0);
  const [isOpens, setIsOpens] = useState();
  const [contactName, setContactName] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(isOpen && recurModal);
  const [showTime, setShowTime] = useState(true);
  const [showEndDate, setShowEndDate] = useState(false);
  const [isTagsOpen, setIsTagsOpen] = useState(false);
  const [fullHeaderObject, setFullHeaderObject] = useState(null);

  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const [customerSearch, setCustomerSearch] = useState("");

  const taskassignedtoref = useRef(null);
  const [dropdownCoord, setDropdownCoord] = useState(null);

  const isFirstRender = useRef(true);
  const [showSubtaskForm, setShowSubtaskForm] = useState(openSubTaskDrawer);

  const storedData = localStorage.getItem("company_data");
  const companyId = storedData ? JSON.parse(storedData) : null;
  // const [leadType, setLeadType] = useState(leadTypeValue);
  // const [hasFormChanged, setHasFormChanged] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [openAddNewPodModal, setOpenAddNewPodModal] = useState(false);
  const [subTaskSelected, setSubtaskSelected] = React.useState({});
  const [openAddProject, setOpenAddProject] = useState(false);
  const [subTaskSerial, setSubTaskSerial] = useState(1);
  const [checklistSerial, setChecklistSerial] = useState(1);
  const [isLinkOpen, setIsLinkOpen] = useState(false);
  const [preSelectedCustomer, setPreSelectedCustomer] = useState({});
  const [funnelClose, setFunnelClose] = useState(true);
  const [headerField, setHeaderField] = useState(null);
  const [selectedSectionLabel, setselectedSectionLabel] = useState();
  const [dropdownOptionsMap, setDropdownOptionsMap] = useState([]);
  const [templateFormated, setTemplateFormated] = useState(null);
  const [getAllFunnel, setGetAllFunnel] = useState(null);
  const [funnelStages, setFunnelStages] = useState([]);
  const [linkedStageTask, setLinkedStageTask] = useState(null);
  const [activeFunnel, setActiveFunnel] = useState(null);
  const drawerRef = useRef(null);

  const hasMyActivities = location.pathname.includes("my-activities")
    ? 1
    : location.pathname.includes("my-assignment")
      ? 0
      : null;

  const extractDateAndTime = (isoString) => {
    if (!isoString) {
      return {
        date: null,
        time: null,
      };
    }
    const date = dayjs(isoString);
    return {
      date: date.format("YYYY-MM-DD"),
      time: date.format("HH:mm:ss"),
    };
  };

  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  const parseWeeklyDays = (daysString) => {
    if (!daysString) {
      return [];
    }

    try {
      return JSON.parse(daysString);
    } catch (error) {
      return [];
    }
  };

  // const initialWeeklyDays = taskid?.weekly_days ? taskid.weekly_days.split(",") : [daysOfWeek[new Date().getDay()]];

  const initialWeeklyDays = taskid?.weekly_days
    ? parseWeeklyDays(taskid.weekly_days)
    : ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
  // : [daysOfWeek[new Date().getDay()]];

  const [
    FetchFieldDropDownValues,
    { data: GetFieldValues, isError: isFieldValuesError, isSuccess: isFieldValuesSuccess, error: FieldValuesError },
  ] = useLazyFetchFieldValuesQuery();

  const { data: customerTaskPodAllCustomer } = useFetchCustomerTaskPodAllCustomerDataQuery({
    token,
    companyId,
    search: customerSearch,
  });

  const [updateTagsData, { data: taskTagsData, isFetching: isFetchingTaskTags }] = usePostTaskTagsMutation();

  //funnel api
  const [fetchFunnelTypes, { data: funnelType, refetch: refetchFunnelTypes }] = useLazyFetchFunnelTypeQuery();
  useEffect(() => {
    fetchFunnelTypes({ id_deployed: true });
  }, []);

  const {
    refetch: refetchGetAllTemplate,
    data: GetAlltemplates,
    isLoading: isGetAllTemplatesLoading,
    isError: isGetAllTemplatesError,
    isSuccess: isGetAllTemplatesSuccess,
    error: GetAllTemplatesError,
  } = useFetchAllTemplateQuery({ myActivities: hasMyActivities });

  //post the task pod data
  const [
    createUpdateTask,
    {
      data: taskPodData,
      isLoading: isTaskPodLoading,
      isError: isTaskPodError,
      isSuccess: isTaskPodSuccess,
      error: TaskPodErrordata,
    },
  ] = usePostApiMutation();
  // for dynamic fields;
  const [
    GetLinkedSectionFields,
    {
      data: fetchLinkedSectionFields,
      isLoading: isFetchLinkedSectionFieldsLoading,
      isError: isFetchLinkedSectionFieldsError,
      isSuccess: isFetchLinkedSectionFieldsSuccess,
      error: FetchLinkedSectionFieldsError,
    },
  ] = useLazyFetchLinkedSectionsFieldsQuery();

  useEffect(() => {
    if (isFetchLinkedSectionFieldsLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isFetchLinkedSectionFieldsSuccess && fetchLinkedSectionFields?.status) {
      // dispatch(
      //   pushAlert({
      //     message: fetchLinkedSectionFields?.message || "Section fields fetched successfully",
      //     type: "success",
      //     visible: true,
      //   })
      // );
      if (fetchLinkedSectionFields?.data) {
        const enhancedData = Object.entries(fetchLinkedSectionFields?.data).reduce(
          (acc, [sectionLabel, sectionData]) => {
            acc[sectionLabel] = {
              ...sectionData,
              fields: sectionData?.fields.map((field) => ({
                ...field,
                apiCall: async () => fetchAndSetFieldOptions(field),
              })),
            };
            return acc;
          },
          {}
        );

        setHeaderField(enhancedData);
        setFullHeaderObject(fetchLinkedSectionFields);
        setFormData({
          ...formData,
          funnel_id: taskid ? fetchLinkedSectionFields?.funnel_type : fetchLinkedSectionFields?.funnel_type || "null",
        });
      }
    }

    if (isFetchLinkedSectionFieldsError) {
      dispatch(
        pushAlert({
          message: FetchLinkedSectionFieldsError?.data?.message || "Failed to fetch section fields",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [
    isFetchLinkedSectionFieldsLoading,
    isFetchLinkedSectionFieldsSuccess,
    isFetchLinkedSectionFieldsError,
    fetchLinkedSectionFields,
  ]);

  useEffect(() => {
    if (!selectedSectionLabel && headerField) {
      const firstLabel = Object.keys(headerField)[0];
      setselectedSectionLabel(firstLabel);
    }
  }, [headerField, selectedSectionLabel]);

  useEffect(() => {
    if (selectedSectionLabel && sectionRefs.current[selectedSectionLabel]) {
      sectionRefs.current[selectedSectionLabel].scrollIntoView({ behavior: "smooth" });
    }
  }, [selectedSectionLabel]);

  //post the task pod data useEffect
  useEffect(() => {
    //loading
    if (isTaskPodLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    //try block
    if (isTaskPodSuccess) {
      dispatch(
        pushAlert({
          message: taskPodData?.message,
          type: taskPodData.success || taskPodData.success ? "success" : "danger", // success is not comming form backend
          visible: true,
        })
      );
      refetchGetAllTasks();
      closePopup();
    }

    // catch block
    if (isTaskPodError) {
      dispatch(pushAlert({ message: TaskPodErrordata?.data?.message, type: "danger", visible: true }));
    }
  }, [isTaskPodSuccess, isTaskPodError, isTaskPodLoading, taskPodData]);

  useEffect(() => {
    if (funnelType?.data?.length > 0) {
      setGetAllFunnel(funnelType?.data);
    }
  }, [funnelType?.data]);

  useEffect(() => {
    getServiceList();
    fetchAllProjectsCall();
  }, []);

  useEffect(() => {
    let existingCustomer = {};
    if (customerId) {
      const filteredItem = customerTaskPodAllCustomer?.data?.customers.find((item) => item.customer_id == customerId);
      existingCustomer = { customer_id: filteredItem?.customer_id, customer_name: filteredItem?.customer_name };
    } else if (selectedCustomer) {
      if (selectedCustomer?.customer_id)
        existingCustomer = {
          customer_id: selectedCustomer?.customer_id,
          customer_name: selectedCustomer?.customer_name,
        };
      else if (selectedCustomer?.id) {
        existingCustomer = { customer_id: selectedCustomer?.id, customer_name: selectedCustomer?.customer_name };
      }
    }

    if (existingCustomer?.customer_id) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customer_name: existingCustomer?.customer_name || "",
        customer_id: existingCustomer?.customer_id || "",
      }));
    }
  }, [customerTaskPodAllCustomer, selectedCustomer]);

  const initialFormData = {
    ...taskid,

    id: taskid?.id || "",
    customer_name: taskid?.customer_name ?? "",
    customer_id: taskid?.customer_id ?? "",
    funnel_id: taskid?.fullHeaderObject?.funnel_type ?? "", //vinay
    customer_display_name: taskid?.customer_display_name || "",
    remarks: "",
    subject: taskid?.subject || "",
    category_id:
      (taskid?.category_id === "all" ? "task" : taskid?.category_id) ||
      (leadTypeValue === "all" ? "task" : leadTypeValue) ||
      "",
    priority: taskid?.priority || "",
    description: taskid?.description || "",
    status: taskid?.status || "Not started",
    task_pod: taskid?.task_pod,
    //due_date:"",
    start_date: extractDateAndTime(taskid?.start_date).date || "",
    // taskid?.selection === "entire"
    //   ? extractDateAndTime(taskid?.recurrence_series_start).date
    //   : extractDateAndTime(taskid?.start?.value).date,
    end_date: extractDateAndTime(taskid?.end_date).date || "",
    // taskid?.selection === "entire"
    //   ? extractDateAndTime(taskid?.recurrence_series_end).date
    //   : extractDateAndTime(taskid?.end?.value).date,
    selection: taskid?.selection,
    start_time: taskid?.start_time || extractDateAndTime(taskid?.start?.value).time || "",
    end_time: taskid?.end_time || extractDateAndTime(taskid?.end?.value).time || "",
    assigned_to: taskid?.assigned_to || [],
    is_recurrence: taskid?.is_recurrence || "",
    recurrence_pattern_id: taskid?.recurrence_pattern_id || "",
    radioselected: "",
    every_weekday: "",
    after_occur: "",
    modifiedspecific: "",

    frequency: taskid?.frequency || "daily",
    interval: taskid?.intervals || 1,
    every_weeks: "",
    daily_recur: "",
    monthly_recur: "",
    yearly_recur: "",
    occurrences: "",
    daily_option: taskid?.daily_option || "every_n_days",
    weekly_days: initialWeeklyDays,
    endBy: "end_by",
    monthly_option: taskid?.monthly_option || "specific_day",
    monthly_week: taskid?.monthly_week || "first",
    day_of_week: taskid?.day_of_week,
    day_of_month: taskid?.day_of_month,
    yearly_option: taskid?.yearly_option || "specific_year",
    sub_tasks: taskid?.sub_tasks || [],
    checklists: taskid?.checklists || [],
    // category_id: taskid?.category_id || leadTypeValue || "",
  };

  console.log(taskid, "taskid in dynamic modal");

  // if (taskid?.selection === "specific") {
  //   initialFormData.update_single_occurrence = 1;
  // } else {
  //   initialFormData.update_entire_series = 1;
  // }

  const [formData, setFormData] = useState(initialFormData || {});
  console.log(taskid, "taskid row");
  const {
    data: customerTaskUserList,
    error: customerTaskUserListerror,
    isLoading: customerTaskUserListLoading,
  } = useFetchCustomerUseListDataQuery({
    token: token?.token,
  });

  const CategoryId = GetAlltemplates?.data?.find(
    (template) => template?.template_name?.toLowerCase() === formData?.category_id?.toLowerCase()
  )?.id;

  useEffect(() => {
    GetLinkedSectionFields({
      TemplateId: templateId || CategoryId,
      IsForm: true,
      is_company_level: !customerTask ? true : false,
    });
  }, [templateId, CategoryId]);

  const default_selected = customerTaskUserList?.data?.filter((item) => item.id == userId);

  const initialSubTaskForm = {
    start_date: formData?.start_date,
    assigned_to: [default_selected?.[0]],
    task_type: "new",
    serial: subTaskSerial,
    status: "Not Started",
  };

  const [subTaskForm, setSubTaskForm] = useState(initialSubTaskForm);

  const initialChecklistForm = {
    name: "",
    status: "Not Started",
    checklist_type: "new",
    serial: checklistSerial,
    delegation: [],
  };
  const [checklistForm, setChecklistForm] = useState(initialChecklistForm);

  useEffect(() => {
    setSubTaskForm(initialSubTaskForm);
  }, [formData?.start_date, subTaskSerial]);

  useEffect(() => {
    setChecklistForm(initialChecklistForm);
  }, [checklistSerial]);

  const subTaskContainerRef = useRef(null);
  const prevSubTasksRef = useRef(formData.sub_tasks);

  // const handleMouseEnter = () => {
  //   setIsSearchBarOpen(!isSearchBarOpen);
  //   fetchPersonData("");

  // };

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();

  const [fetchAllProjects, { data: projectsAllData, isFetching: projectsAllDataLoading }] =
    useLazyFetchAllProjectsQuery();
  const [createProjectJob, { data: projectJobData, isFetching: isProjectJobCreating }] = useCreateJobMutation();
  const [fetchFieldValues, { data: projectFieldList, isFetching: projectFieldListLoading }] =
    useLazyGetProjectTaskEnumQuery();
  const [fetchServiceList, { data: serviceList, isFetching: serviceListLoading }] = useLazyFetchServiceListQuery();
  const { data: customerCommonData, error, isLoading: commonDataLoading } = useFetchCommonDataQuery();
  const [fetchTaskTags, { data: TaskTagsList, isFetching: isTaskTagsLoading }] = useLazyGetTaskTagsQuery();

  useEffect(() => {
    fetchTaskTags("", false);
  }, []);
  useEffect(() => {
    if (isProjectJobCreating) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isProjectJobCreating, commonDataLoading]);

  const CustomerSearchChange = (event, newInputValue) => {
    setCustomerSearch(newInputValue);
  };

  const handleCustomerChange = (event, newValue) => {
    if (newValue) {
      setFormData({
        ...formData,
        customer_name: newValue.customer_name,
        customer_id: newValue.customer_id,
      });
    } else {
      setFormData({
        ...formData,
        customer_name: "",
        customer_id: "",
      });
    }
  };

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: token?.token, data: data, companyId: companyId?.company_id });
  };

  const fetchAllProjectsCall = () => {
    fetchAllProjects({ customerId: formData?.customer_id });
  };

  const handleMouseEnter = (index) => {
    setIsSearchBarOpen((prevState) => ({
      ...prevState,
      [index]: true,
    }));
    setDropdownCoord((prevState) => {
      return getCreatePortalPosition();
    });
    fetchPersonData("");
  };

  useEffect(() => {
    if (checkListOpen) {
      setShowSubtaskForm("project");
    }
  }, [checkListOpen]);

  const handleMouseLeave = (index) => {
    setIsSearchBarOpen((prevState) => ({
      ...prevState,
      [index]: false,
    }));
    setDropdownCoord(null);
  };

  const openPopup = () => {
    setIsPopupOpen((prev) => !prev);
    setShowNotification(false);
    setShowSubtaskForm(false);
  };
  const closePopupRecur = () => {
    setIsPopupOpen(false);
  };

  // const [formData, setFormData] = useState({
  //   id:  taskid?.id || "",
  //   subject: taskid?.subject || "",
  //   category_id: taskid?.category_id || "",
  //   priority: taskid?.priority || "",
  //   description: taskid?.description || "",
  //   status: taskid?.status || "",
  //   // due_date: taskid?.due_date || "",
  //   task_pod: taskid?.task_pod || "",
  //   start_date: taskid?.start_date || taskid?.start?.value || "",
  //   end_date: taskid?.end_date || taskid?.end?.value || "",
  //   start_time:  taskid?.start_time  || "",
  //   end_time:  taskid?.end_time || "",
  //   assigned_to: taskid?.assigned_to || "",
  //   is_recurrence:  taskid?.is_recurrence || "",
  //   recurrence_pattern_id:  taskid?.recurrence_pattern_id || "",
  //   radioselected:  "",
  //   every_weekday:  "",
  //   after_occur:  "",
  //   modifiedspecific: taskid?.update_entire_series === 0,

  // });

  const getRoundedTime = () => {
    const now = new Date();

    // Add 30 minutes to the current time
    now.setMinutes(now.getMinutes() + 30);

    // Round the minutes to the nearest 30-minute interval
    const minutes = now.getMinutes();
    const roundedMinutes = minutes < 30 ? 0 : 30;

    now.setMinutes(roundedMinutes);
    now.setSeconds(0, 0); // Clear seconds and milliseconds

    // Format hours and minutes to match the dropdown format (e.g., 6:00, 6:30)
    const hours = now.getHours() % 12 || 12; // Convert to 12-hour format
    const formattedTime = `${hours}:${roundedMinutes === 0 ? "00" : "30"}`;

    return formattedTime;
  };

  useEffect(() => {
    if (formData?.selection === "specific" || formData?.is_recurrence === 0) {
      setFormData((prevData) => ({
        ...prevData,
        update_single_occurrence: 1,
        update_entire_series: 0,
      }));
    } else if (formData?.selection === "entire" || formData?.is_recurrence === 1) {
      setFormData((prevData) => ({
        ...prevData,
        update_single_occurrence: 0,
        update_entire_series: 1,
      }));
    }
  }, [formData.selection, formData.is_recurrence]);

  // useEffect(() => {
  //   if (subTaskContainerRef.current) {
  //     // Scroll to the bottom of the task container
  //     subTaskContainerRef.current.scrollTop = subTaskContainerRef.current.scrollHeight;
  //   }
  // }, [formData.sub_tasks]);

  useEffect(() => {
    if (subTaskContainerRef.current) {
      // Compare previous and current subtask length to detect addition
      if (formData.sub_tasks?.length > prevSubTasksRef.current?.length) {
        // Scroll to the bottom if a new subtask was added
        subTaskContainerRef.current.scrollTop = subTaskContainerRef.current.scrollHeight;
      }

      // Update the reference to the current subtask list
      prevSubTasksRef.current = formData.sub_tasks;
    }
  }, [formData.sub_tasks]);

  const [defaultFormData, setDefaultFormData] = useState(initialFormData);

  const [startDate, setStartDate] = useState(
    // taskid?.start_date ? new Date(taskid?.start_date) :
    formData?.start_date ? new Date(formData.start_date) : new Date()
  );

  const cross = true;

  const [endDate, setEndDate] = useState(
    // taskid?.end_date ? new Date(taskid?.end_date) :
    formData?.end_date ? new Date(formData?.end_date) : getDatePlusOne(new Date())
  );
  const [showNotification, setShowNotification] = useState(activeModal ? true : false);
  const handleNotification = () => {
    setShowNotification(!showNotification);
  };

  const addSubtask = () => {
    if (!subTaskForm?.subject?.trim() || subTaskForm.assigned_to.length === 0) {
      dispatch(pushAlert({ message: "Enter Mandatory Fields.", type: "danger", visible: true }));
      return;
    }
    setShowSubtaskForm(formData?.category_id?.toLowerCase());
    if (subTaskForm?.task_type === "new") {
      setSubTaskSerial((prevSerial) => prevSerial + 1);
    } else {
      setSubTaskForm(initialSubTaskForm);
    }
    if (!isFormDisabled) {
      setFormData((prevData) => {
        const exists = prevData.sub_tasks.some((eachSubTask) =>
          subTaskForm?.task_type === "new"
            ? eachSubTask?.serial === subTaskForm?.serial
            : eachSubTask.id === subTaskForm.id
        );
        return {
          ...prevData,
          sub_tasks: exists
            ? prevData?.sub_tasks?.map((eachSubTask) =>
                (
                  subTaskForm?.task_type === "new"
                    ? eachSubTask?.serial === subTaskForm?.serial
                    : eachSubTask.id === subTaskForm.id
                )
                  ? subTaskForm
                  : eachSubTask
              )
            : [...prevData.sub_tasks, subTaskForm],
        };
      });
    }
  };

  const addChecklist = () => {
    if (!checklistForm?.fs_item?.trim() || checklistForm?.delegation?.length === 0) {
      dispatch(pushAlert({ message: "Enter Mandatory Fields.", type: "danger", visible: true }));
      return;
    }
    setShowSubtaskForm(formData?.category_id?.toLowerCase());
    if (checklistForm?.checklist_type === "new") {
      setChecklistSerial((prevSerial) => prevSerial + 1);
    } else {
      setChecklistForm(initialChecklistForm);
    }
    if (!isFormDisabled) {
      setFormData((prevData) => {
        const exists = prevData.checklists.some((eachChecklist) =>
          checklistForm?.checklist_type === "new"
            ? eachChecklist?.serial === checklistForm?.serial
            : eachChecklist.id === checklistForm.id
        );
        return {
          ...prevData,
          checklists: exists
            ? prevData?.checklists?.map((eachChecklist) =>
                (
                  checklistForm?.checklist_type === "new"
                    ? eachChecklist?.serial === checklistForm?.serial
                    : eachChecklist.id === checklistForm.id
                )
                  ? checklistForm
                  : eachChecklist
              )
            : [...prevData.checklists, checklistForm],
        };
      });
    }
  };

  // const [formData, setFormData] = useState({
  //   subject: "",
  //   category_id: "",
  //   priority: "",
  //   description: "",
  //   contact_name: "",
  //   status: "",
  //   due_date: "",
  //   task_pod: "",
  //   start_date: "",
  //   end_date: "",
  //   owner: "",
  //   is_recurrence: "",
  // });

  const handleCheck = (index, event) => {
    setSearchTerm((prevState) => ({
      ...prevState,
      [index]: event.target.value,
    }));
  };

  const handleDeleteSubtask = (listOfIndex, type, isNew) => {
    const updatedSubtasks = formData?.[type === "checklist" ? "checklists" : "sub_tasks"].filter(
      (eachSubTask) => !Boolean(listOfIndex.includes(isNew ? eachSubTask?.serial : eachSubTask?.id))
    );
    setFormData((prevFormData) => ({
      ...prevFormData,
      [type === "checklist" ? "checklists" : "sub_tasks"]: updatedSubtasks,
    }));
  };

  const handleRemoveNoSubjectSubTask = () => {
    const updatedSubtasks = formData.sub_tasks.filter((eachSubTask, i) => eachSubTask.subject !== "");
    setFormData((prevFormData) => ({ ...prevFormData, sub_tasks: updatedSubtasks }));
  };

  // Function to handle changes in subtask fields
  // const handleSubtaskChange = (index, e) => {
  //   const { name, value } = e.target;
  //   const updatedSubtasks = [...formData.sub_tasks];
  //   updatedSubtasks[index] = { ...updatedSubtasks[index], [name]: value };
  //   setFormData(prevData => ({
  //     ...prevData,
  //     sub_tasks: updatedSubtasks,
  //   }));
  // };

  const handleSubtaskChange = (index, e) => {
    const { name, type, value, checked } = e.target;

    // Determine the correct value to use
    const inputValue = type === "checkbox" ? checked : value;

    const updatedSubtasks = [...formData?.sub_tasks];
    updatedSubtasks[index] = { ...updatedSubtasks[index], [name]: inputValue };

    setFormData((prevData) => ({
      ...prevData,
      sub_tasks: updatedSubtasks,
    }));
  };

  const handleChecklistChange = (index, e) => {
    const { name, type, value, checked } = e.target;

    // Determine the correct value to use
    const inputValue = type === "checkbox" ? checked : value;

    const updatedSubtasks = [...formData?.checklists];
    updatedSubtasks[index] = { ...updatedSubtasks[index], [name]: inputValue };

    setFormData((prevData) => ({
      ...prevData,
      checklists: updatedSubtasks,
    }));
  };

  const ActivateRecur = (recurrdata) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      ...recurrdata,
    }));
    closePopupRecur();
  };

  // useEffect(() => {
  //   if (startDate) {
  //     let combinedDate = startDate.toLocaleDateString('en-GB');

  //     if (endDate && startDate.getTime() !== endDate.getTime()) {
  //       combinedDate += ` - ${endDate.toLocaleDateString('en-GB')}`;
  //     }

  //     setFormData(prevFormData => ({
  //       ...prevFormData,
  //       due_date: combinedDate,
  //     }));
  //   }
  // }, [startDate, endDate]);

  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      start_date: startDate ? startDate.toISOString() : "",
      end_date: endDate ? endDate.toISOString() : "",
    }));

    // setDefaultFormData(prevState => ({
    //   ...prevState,
    //   start_date: startDate ? startDate.toISOString() : "",
    //   end_date: endDate ? endDate.toISOString() : "",
    // }));

    //commenting this, because it was setting the lead type back to task, and was creating some problem, don't
    //know why was this written initially
    // return () => {
    //   setLeadTypeValue("task");
    // };
  }, [startDate, endDate]);

  const validationRules = useMemo(
    () => ({
      customer_id: {
        required: true,
        errorMessage: "Customer Name is Required.",
        compulsory: true,
      },
      subject: {
        required: true,
        errorMessage: "Subject is required.",
        compulsory: true,
      },
      assigned_to: {
        required: true,
        errorMessage: "task must be assigned.",
        compulsory: true,
      },
      sub_tasks: {
        required: true,
        errorMessage: "sub_tasks ",
        // compulsory: category_id?.toLowerCase()==="task",
      },
      project_id: {
        required: true,
        errorMessage: "Project Name is required.",
        compulsory: formData?.category_id?.toLowerCase() === "project",
      },
      service_id: {
        required: true,
        errorMessage: "Service Type is required",
        compulsory: formData?.category_id?.toLowerCase() === "project",
      },
      start_date: {
        required: true,
        errorMessage: "Job Start Date is required.",
        compulsory: formData?.category_id?.toLowerCase() === "project",
      },
      end_date: {
        required: true,
        errorMessage: "Job Start End is required.",
        compulsory: formData?.category_id?.toLowerCase() === "project",
      },
      category_id: {
        required: true,
        errorMessage: "Category is required.",
        compulsory: true,
      },
      // due_date: {
      //   required: true,
      //   errorMessage: 'Due is required.',
      // }
    }),
    [formData?.category_id]
  );
  const { errors, isFormValid } = TaskFormValidation(formData, validationRules);

  const getHasError = (errors) => {
    let hasErrors = false;
    if (typeof errors?.subject !== "undefined" || typeof errors?.assigned_to !== "undefined") {
      hasErrors = true;
    }

    if (errors?.sub_tasks?.subject && errors?.sub_tasks?.subject.length > 0) {
      errors?.sub_tasks?.subject.forEach((task) => {
        if (task?.value !== "subjectFound") {
          hasErrors = true;
        }
      });
    }

    if (errors?.sub_tasks?.assigned_to && errors?.sub_tasks?.assigned_to.length > 0) {
      errors.sub_tasks.assigned_to.forEach((task) => {
        if (task?.value !== "assignedToFound") {
          hasErrors = true;
        }
      });
    }

    const hasEmptySubtaskSubject = formData?.sub_tasks?.some((subtask) => subtask?.subject === "");
    if (hasEmptySubtaskSubject) {
      hasErrors = true;
    }
    const hasEmptyChecklistSubject = formData?.checklists?.some((subtask) => subtask?.fs_item === "");
    if (hasEmptyChecklistSubject) {
      hasErrors = true;
    }
    hasErrors = Object.keys(validationRules).some(
      (eachKey) => validationRules[eachKey]?.compulsory && errors[eachKey]?.[0]
    );

    return hasErrors;
  };

  const [showRemark, setShowRemark] = useState(false);

  // const [categoryChange, setCategoryChange] = useState({});
  const [category, setCategory] = useState({ name: "category_id", value: leadTypeValue });

  const [taskPods, setTaskPods] = useState([]);

  //OnCHange for Dynamic FIelds
  const handleGerneralInputChange = (event) => {
    // event.preventDefault();
    const { name, value } = event.target;

    if ((name === "target_delivery_date" || name === "billing_date") && value == "Invalid date") {
      return;
    }

    // Handle showing remark based on category_id value (for example, if it's 17)
    if (value === "17") {
      setShowRemark(true);
    } else {
      setShowRemark(false);
    }
    if (name === "task_pod") {
      if (value === "addNew") {
        setOpenAddNewPodModal(true);
        setFormData((prevFormData) => ({ ...prevFormData, task_pod: "" }));

        return;
      }
    }

    // Handle showing/hiding "Opens" based on category_id value
    // if (name === "category_id") {
    //   if (value === "Task") {
    //     setIsOpens(true);
    //   } else {
    //     setIsOpens(false);
    //   }
    //   setRefreshKey((prevKey) => prevKey + 1);
    // }

    // Handle the status change for the main task and update subtasks
    if (name === "status") {
      // Update the main task status
      setFormData((prevFormData) => {
        const newStatus = value;

        // Update subtasks based on the new main task status
        const updatedSubTasks = taskid?.sub_tasks?.map((subtask) => {
          // Update subtask status if not already one of the selected statuses
          if (
            newStatus === "Completed" &&
            subtask.status !== "Completed" &&
            subtask.status !== "Drop" &&
            subtask.status !== "Cancelled"
          ) {
            return { ...subtask, status: "Completed" };
          } else if (
            newStatus === "Drop" &&
            subtask.status !== "Completed" &&
            subtask.status !== "Drop" &&
            subtask.status !== "Cancelled"
          ) {
            return { ...subtask, status: "Drop" };
          } else if (
            newStatus === "Cancelled" &&
            subtask.status !== "Completed" &&
            subtask.status !== "Drop" &&
            subtask.status !== "Cancelled"
          ) {
            return { ...subtask, status: "Cancelled" };
          }
          return subtask;
        });

        return {
          ...prevFormData,
          status: newStatus, // Update the main task status
          sub_tasks: updatedSubTasks || [], // Update the subtasks
        };
      });
    }
    if (name === "funnel_id") {
      setFunnelClose(true);
    }

    if (name === "category_id") {
      if (formData?.category_id?.toLowerCase() === "project" && value?.toLowerCase() !== "project") {
        setCategory({ name: "category_id", value: value });
        setOpenConfirmationDialog("discard_project_and_switch_to_other_task");
      } else if (
        formData?.category_id?.toLowerCase() === "task" &&
        value?.toLowerCase() !== "task" &&
        formData["sub_tasks"]?.length
      ) {
        setCategory({ name: "category_id", value: value });
        setOpenConfirmationDialog("discard_subtask_and_switch_to_non-task");
      } else {
        setLeadTypeValue(value);
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
      }
    } else {
      setFormData((prevFormData) => {
        return {
          ...prevFormData,
          [name]: value,
        };
      });
    }

    setShowNotification(false);
    // setShowSubtaskForm("");
    setIsPopupOpen(false);
  };

  const handleInputChange = (event) => {
    console.log("inside handleinputchange for project0");
    // event.preventDefault();
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    setShowNotification(false);
    // setShowSubtaskForm("");
    setIsPopupOpen(false);
  };

  const handleCategoryUpdate = () => {
    const { name, value } = category || {};
    setLeadTypeValue(value);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
      ...(value?.toLowerCase() === "task" && { assigned_to: prevFormData.assigned_to.slice(0, 1) }),
      sub_tasks: [],
    }));

    // setCategory();
  };

  const [dueDate, setDueDate] = useState();
  //const { data: taskRecurrenceAll, refetch: taskRecurrenceFetch } = useFetchTaskGetOrgAccordingQuery({ token });

  // useEffect(() => {
  //   if(isEditTask){
  //   fetchTaskEditData(taskid);
  // }}, [taskid]);

  const handleInputDateChange = (value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      due_date: new Date(value?.due_date),
    }));
  };

  //   useEffect(() => {
  //     const normalizeValues = (obj) => {
  //       return Object.fromEntries(
  //           Object.entries(obj).map(([key, value]) => [key, value === null ? "" : value])
  //       );
  //   };

  //   const isFormChanged = JSON.stringify(normalizeValues(formData)) !== JSON.stringify(normalizeValues(initialFormData));
  //   setHasFormChanged(isFormChanged)
  // }, [formData]);

  // useEffect(() => {
  //   const listOfEntries = ["customer_id", "subject"];
  //   const isFormChangedFlag = listOfEntries.some((key) => formData[key] !== initialFormData[key]);
  //   setHasFormChanged({
  //     isFormChanged: isFormChangedFlag,
  //     isSubtaskChanged: JSON.stringify(formData?.sub_tasks) !== JSON.stringify(initialFormData?.sub_tasks),
  //   });
  // }, [formData]);

  const handleRemoveSubtasks = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      sub_tasks: [],
    }));
  };

  const handleRemoveChecklist = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      checklists: [],
    }));
  };
  // useEffect(() => {
  //   if (leadType?.toLowerCase() === "project") {
  //     setOpenConfirmationDialog(leadType === "project" && formData?.sub_tasks?.some((subtask) => subtask.subject));
  //   }

  // }, [leadType]);

  //form submitted function
  const handleSubmitTask = async (event) => {
    event.preventDefault();

    const {
      frequency,
      interval,
      day_of_month,
      day_of_week,
      start_date,
      end_date,
      update_entire_series,
      weekly_days,
      yearly_option,
      occurrences,
      monthly_week,
      monthly_option,
      daily_option,
      ...RemFormData
    } = formData;

    const recurrence = {
      frequency,
      interval,
      day_of_month,
      day_of_week,
      start_date,
      end_date,
      weekly_days,
      yearly_option,
      occurrences,
      monthly_week,
      monthly_option,
      daily_option,
    };
    const OnlyDynamicFields = { ...RemFormData, start_date, end_date };

    const payload = {
      row_id: taskid?.id ? taskid?.id : null,
      template_id: templateId,
      data: OnlyDynamicFields,
      // recurrence,
      update_single_recurrence: taskid && formData?.update_single_occurrence ? true : false,
      edit_entire_recurrence: taskid && formData?.update_entire_series ? true : false,
    };
    if (formData?.is_recurrence) {
      payload.recurrence = recurrence;
    }
    if (externalApi) {
      externalApi?.createUpdateTask(formData);
    } else {
      createUpdateTask({
        data: payload,
        url: `${NODE_URL}template/create-task?template_id=${propTemplateId}&row_id=${propTemplateId ? taskid?.id : null}`,
      });
    }
  };

  useEffect(() => {
    if (!taskid) return;

    if (taskid.end_date) {
      setShowEndDate(true);
    }

    if (taskid.start_time !== "00:00:00" || taskid.end_time !== "00:00:00") {
      setShowTime(false);
    }
  }, [taskid]);

  useEffect(() => {
    if (customerTaskUserList) {
      const default_selected = customerTaskUserList?.data?.filter((item) => item?.id == userId);
      setFormData((prevFormData) => {
        const alreadyExists = prevFormData?.assigned_to.some(
          (item) => item?.id === default_selected[0]?.id // Assuming objects have an 'id' field for uniqueness
        );

        if (alreadyExists || taskid) {
          return prevFormData; // Return the previous state without changes
        }

        return {
          ...prevFormData,
          assigned_to: [...prevFormData?.assigned_to, default_selected[0]],
        };
      });

      setSubTaskForm((prevFormData) => ({
        ...prevFormData,
        assigned_to: [default_selected?.[0]],
      }));

      setChecklistForm((prevFormData) => ({
        ...prevFormData,
        delegation: [default_selected?.[0]],
      }));
    }
  }, [customerTaskUserList, subTaskSerial, checklistSerial]);

  const handleInsert = (item) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      assigned_to: [...prevFormData.assigned_to, item],
    }));
  };

  const tableDetail = {
    tableidclass: "taskmodelowner",
  };

  const handlePersonData = (value) => {
    setContactName(value.name);
  };

  // const { data: customerTaskPodList } = useFetchCustomerAllTaskPodDataQuery({
  //   token: token?.token,
  //   company: parsedCompanyData,
  // });

  const getUniversalTaskType = (value) => {
    if (value) {
      if (formData?.category_id === "project") {
        return "project";
      } else {
        return "task";
      }
    }
    return "";
  };
  const { data: newTaskpodsAll, refetch: refetchAllTaskpods } = useFetchAllTaskPodsQuery({
    token: token?.token,
    type: getUniversalTaskType(formData?.category_id),
    customerId: formData?.customer_id ?? "",
    companyId: parsedCompanyData?.company_id,
  });

  useEffect(() => {
    const newId = GetAlltemplates?.data?.find(
      (template) => template.template_name?.toLowerCase() === formData?.category_id?.toLowerCase()
    )?.id;

    if (newId && !externalApi) {
      console.log("new id", newId);

      const newParams = new URLSearchParams(searchParams);

      // Get current path
      const pathParts = location.pathname.split("/");

      // Replace the last part with the newId
      pathParts[pathParts.length - 1] = newId;

      // Build the new path
      const newPath = pathParts.join("/");

      navigate({
        pathname: newPath,
        search: newParams.toString(),
      });
    }
  }, [GetAlltemplates, formData?.category_id]);
  // to extract the value key from the uuid of the template

  useEffect(() => {
    if (GetAlltemplates) {
      console.log("alltemplates123", GetAlltemplates?.data);

      const transformedTemplates = GetAlltemplates?.data?.map((template) => ({
        label: template?.template_name,
        value: template?.template_name, // or any custom value
        rightTab: String(template.section_count ?? 0),
        created_at: template?.created_at,
        created_by: template?.created_by,
        updated_at: template?.updated_at,
        updated_by: template?.updated_by,
        id: template?.id,
        is_deployed: template?.is_deployed,
      }));

      setTemplateFormated(transformedTemplates);
    }
  }, [GetAlltemplates]);

  const matchedOption = templateFormated?.find((item) => item.id === formData?.category_id)?.value;
  useEffect(() => {
    if (newTaskpodsAll) {
      setTaskPods(newTaskpodsAll);
    }
  }, [newTaskpodsAll]);

  const StartDateChange = (date) => {
    setStartDate(date);
    const nextDay = new Date(date);
    nextDay.setDate(nextDay.getDate());
    setEndDate(nextDay);
  };

  const generateTimeOptions = () => {
    const times = [];
    for (let i = 0; i < 24; i++) {
      const hour = i < 10 ? `0${i}` : i;
      times.push(`${hour}:00:00`);
      times.push(`${hour}:30:00`);
    }
    return times;
  };

  const roundUpToNextHalfHour = (time) => {
    // Extract hours and minutes from the input time
    const [hours, minutes] = time.split(":").map(Number);

    // Calculate the next half-hour mark
    const roundedMinutes = minutes < 30 ? 30 : 0;
    const roundedHours = minutes < 30 ? hours : (hours + 1) % 24;

    // Format hours and minutes into HH:MM with seconds always set to 00
    return `${String(roundedHours).padStart(2, "0")}:${String(roundedMinutes).padStart(2, "0")}:00`;
  };

  const StartTimeElement = () => {
    const rawStartTime = formData?.start_time || "00:00:00"; // Default to "00:00:00" if undefined
    // const roundedStartTime = roundUpToNextHalfHour(rawStartTime.slice(0, 5));

    return (
      <div className="flex w-full">
        <select
          name="start_time"
          value={rawStartTime}
          onChange={handleInputChange}
          className={`form-select h-[30px] ${isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} rounded-md border cursor-pointer focus:outline-hidden focus:ring-0 focus:border-1D5D9B  w-full active:border active:border-DFE2E5 text-xs block h-7 py-0 min-w-fit`}
          disabled={showTime}
        >
          {generateTimeOptions().map((time) => (
            <option key={time} value={time}>
              {time.slice(0, 5)}
            </option>
          ))}
        </select>
        {/* <div className="absolute right-[0.5px] top-1/2 transform -translate-y-1/2 pointer-events-none ">
          <TimerImg />
        </div> */}
      </div>

      // <LocalizationProvider dateAdapter={AdapterDayjs} >
      //       <DemoContainer components={['TimePicker']} >
      //            <TimePicker label="Basic time picker" />
      //       </DemoContainer>
      // </LocalizationProvider>
    );
  };

  const EndTimeElement = () => {
    const rawStartTime = formData?.end_time || "00:00:00";
    // const roundedStartTime = roundUpToNextHalfHour(rawStartTime.slice(0, 5));

    return (
      <div className="flex w-full">
        <select
          name="end_time"
          value={rawStartTime}
          onChange={handleInputChange}
          className={`form-select  rounded-md border h-[30px] ${isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 py-0 min-w-fit`}
          disabled={showTime}
        >
          {generateTimeOptions().map((time) => (
            <option key={time} value={time}>
              {time.slice(0, 5)}
            </option>
          ))}
        </select>
        {/* <div className="absolute right-[0.5px] top-1/2 transform -translate-y-1/2 pointer-events-none">
          <TimerImg />
        </div> */}
      </div>
    );
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (name === "showTime") setShowTime(checked);
    if (name === "showEndDate") setShowEndDate(checked);

    if (!checked) {
      if (name === "showTime")
        setFormData((prevFormData) => {
          const newFomData = { ...prevFormData };
          delete newFomData["start_time"];
          delete newFomData["end_time"];
          return newFomData;
        });
      if (name === "showEndDate")
        setFormData((prevFormData) => ({
          ...prevFormData,
          end_date: prevFormData?.start_date,
        }));
      // setFormData((prevFormData) => {
      //   const newFomData = { ...prevFormData };
      //   delete newFomData["end_date"]
      //   return newFomData
      // });
    }
  };

  const handleSelectPerson = (event, value, personCountAllowed) => {
    event.preventDefault();

    const isTaskCategory = formData?.category_id?.toLowerCase() === "task";
    const currentAssignedTo = formData.assigned_to || [];

    if (isTaskCategory) {
      const index = currentAssignedTo.indexOf(value);
      if (index === -1) {
        setFormData({
          ...formData,
          assigned_to: [...formData?.assigned_to, value]?.slice(-personCountAllowed),
        });
      } else {
        setFormData({
          ...formData,
          assigned_to: [],
        });
      }
    } else {
      const index = currentAssignedTo.indexOf(value);
      if (index === -1) {
        setFormData({
          ...formData,
          assigned_to: [...currentAssignedTo, value],
        });
      } else {
        setFormData({
          ...formData,
          assigned_to: currentAssignedTo.filter((item) => item !== value),
        });
      }
    }
  };

  const handleRemovePerson = (e, person) => {
    e.stopPropagation();
    setFormData((prevFormData) => ({
      ...prevFormData,
      assigned_to: prevFormData.assigned_to.filter((item) => item.id !== person.id),
    }));
  };

  const handleSubTaskPerson = (subTaskIndex, value) => {
    const updatedSubTasks = [...formData.sub_tasks];

    // Update the subtask at the specified index
    const updatedSubTask = { ...updatedSubTasks[subTaskIndex] };

    // Check if the person is already assigned
    const isAlreadyAssigned = updatedSubTask.assigned_to.some((person) => person.id === value.id);

    if (isAlreadyAssigned) {
      // Remove the person if already assigned
      updatedSubTask.assigned_to = [];
    } else {
      // Add the person (only one select at a time)
      updatedSubTask.assigned_to = [value];
    }

    // Update the subtask in the array
    updatedSubTasks[subTaskIndex] = updatedSubTask;

    // Update the form data with the new subtask assignments
    setFormData({
      ...formData,
      sub_tasks: updatedSubTasks,
    });
  };

  const getCreatePortalPosition = () => {
    if (taskassignedtoref.current) {
      const rect = taskassignedtoref.current.getBoundingClientRect(); // Get the bounding rectangle

      const left = rect.left + 18;
      const top = rect.top + 5;

      return {
        top: top + window.scrollY,
        left: left + window.scrollX,
        borderRadius: "5",
      };
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;

      if (formData?.status && formData?.sub_tasks?.length && formData?.status?.toLowerCase() === "completed") {
        handleMainTaskCheckboxChange({ target: { checked: formData?.status?.toLowerCase() === "completed" } });
      }
    }
  }, [formData]);

  useEffect(() => {
    if (formData?.status?.toLowerCase() === "hold" || formData?.status?.toLowerCase() === "not started") {
      return;
    }

    const allSubtasksInProgress = formData?.sub_tasks?.some(
      (subtask) =>
        subtask.status?.toLowerCase() === "not started" ||
        subtask.status?.toLowerCase() === "work in progress" ||
        subtask.status?.toLowerCase() === "hold"
    );

    if (allSubtasksInProgress) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        status: "Work in Progress",
      }));
    }
  }, [formData?.sub_tasks]);

  const handleMainTaskCheckboxChange = (e) => {
    const newStatus = e.target.checked ? "Completed" : "Work in Progress";

    setFormData({
      ...formData,
      status: newStatus,
      sub_tasks: formData?.sub_tasks?.map((subtask) => {
        if (
          subtask.status?.toLowerCase() !== "completed" &&
          subtask.status?.toLowerCase() !== "cancelled" &&
          subtask.status?.toLowerCase() !== "drop"
        ) {
          return {
            ...subtask,
            status: newStatus === "Completed" ? "Completed" : "Work in Progress",
          };
        }
        return subtask;
      }),
    });
  };

  const handleSubtaskCheckboxChange = (subtaskData, isChecked, index) => {
    const updatedSubtasks = formData.sub_tasks.map((subtask, subtaskIndex) => {
      if (subtask.id === subtaskData?.id && subtaskIndex === index) {
        if (isChecked) {
          return {
            ...subtask,
            status: "Completed",
          };
        } else {
          return {
            ...subtask,
            status: "Work in Progress",
          };
        }
      }
      return subtask;
    });

    setFormData({
      ...formData,
      sub_tasks: updatedSubtasks,
    });
  };

  const isEditTask = Boolean(taskid?.id);

  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const isFormDisabled = formDisabledStatuses.includes(formData?.status);

  const handleAddProject = () => {
    setOpenAddProject("add");
  };

  const getFieldValue = async (enumValues, entity = "project") => {
    const payload = {
      entity: entity,
      field: enumValues,
    };
    const response = await fetchFieldValues({ payload }).unwrap();
    if (response?.success) {
      dispatch(pushAlert({ message: response?.message, type: "success", visible: true }));
    } else {
      dispatch(pushAlert({ message: response?.message, type: "danger", visible: true }));
    }
  };

  const getServiceList = () => {
    const payload = {
      customer_id: formData?.customer_id,
    };
    fetchServiceList({ payload });
  };

  const projectFields0 = [
    {
      id: "customer_id",
      name: "customer_id",
      label: "Customer",
      type: "select",
      value: formData?.customer_id,
      displayValueKey: "customer_name",
      defaultOptions: customerTaskPodAllCustomer?.data?.customers?.map((item) => ({
        label: item.customer_name,
        value: item.customer_id,
      })),
      colspan: "2",
      // hide: formData?.project_id,
      isMandatory: true,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    // {
    //   id: "category_id",
    //   name: "category_id",
    //   label: "Category",
    //   type: "select",
    //   value: matchedValue,
    //   defaultOptions: templateFormated
    //     ?.filter((item) => item.is_deployed !== 0) // ✅ filter first
    //     .map((item) => ({
    //       label: getSentenceCase(item.value),
    //       value: item.value,
    //     })),
    //   disabled: Boolean(taskid?.customer_id),
    //   colspan: "2",
    //   // hide: formData?.project_id,
    //   isMandatory: true,
    //   useFetchHook: useLazyGetProjectTaskEnumQuery,
    // },
    {
      id: "project_id",
      name: "project_id",
      label: "Project Name",
      type: "select",
      value: formData?.project_id,
      displayValueKey: "project_name",
      disabled: !Boolean(formData?.customer_id),

      // useFetchHook:useLazyFetchAllProjectsQuery,
      // hookPayload:({ customerId: formData?.customer_id }),
      apiCall: fetchAllProjectsCall,
      dynamicOptions: projectsAllData?.data?.map((eachItem) => ({
        label: eachItem.project_name,
        value: eachItem.project_id,
      })),
      isLoading: projectsAllDataLoading,
      hide:
        headerField &&
        Object?.entries(headerField)?.some(([sectionLabel]) => sectionLabel === "Project Information") === true
          ? false
          : true,
      colspan: "2",
      addButton: true,
      addButtonLabel: "+ Add New Project",
      addButtonAction: handleAddProject,
      isMandatory: true,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },

    {
      id: "funnel_id",
      name: "funnel_id",
      label: formData?.category_id === "project" ? "Tax Milestone" : "Funnel", // as told by bhatia sir on 0107, didnt changed the condition, may be needed to revert it back
      type: "select",
      value: formData?.funnel_id,
      dynamicOptions: getAllFunnel?.map((eachItem) => ({ label: eachItem?.funnel_name, value: eachItem?.id })),

      // apiCall: function() {
      //   return getFieldValue("job_status","job");
      // },
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "task",
        field: "funnel_id",
      },
      disabled: true,
      hide: fullHeaderObject && fullHeaderObject["funnel_type"] ? false : true || true,
    },

    {
      id: "service_id",
      name: "service_id",
      label: "Link To Service",
      type: "select",
      value: formData?.service_id,
      displayValueKey: "service_name",

      colspan: "2",
      noKeyboardNavigation: true,
      childrenKey: "sub_services",
      // apiCall: function () {
      //   return getServiceList();
      // },
      dynamicOptions: serviceList?.data?.map((eachItem) => ({
        label: eachItem?.name,
        value: eachItem?.id,
        children: eachItem?.sub_services?.map((eachTask) => ({
          label: eachTask?.name,
          value: eachTask?.id,
        })),
      })),
      isLoading: serviceListLoading,
      isMandatory: formData?.category_id === "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hide:
        headerField &&
        Object?.entries(headerField)?.some(([sectionLabel]) => sectionLabel === "Service Information") === true
          ? false
          : true,
    },
  ];

  const projectFields1 = [
    {
      id: "job_name",
      name: "job_name",
      label: "Job Name",
      type: "text",
      value: formData?.job_name,
      disabled: true,
      colspan: "2",
      // isMandatory: true,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },

    {
      id: "job_status_funnel",
      name: "job_status_funnel",
      label: formData?.category_id === "project" ? "Tax Milestone" : "Funnel", // as told by bhatia sir on 0107, didnt changed the condition, may be needed to revert it back
      type: "select",
      value: formData?.job_status_funnel,
      // dynamicOptions:projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
      isLoading: projectFieldListLoading,
      // apiCall: function() {
      //   return getFieldValue("job_status","job");
      // },
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "task",
        field: "job_status_funnel",
      },

      hide: !["deal", "project"].includes(formData?.category_id?.toLowerCase()),
      colspan: "2",
    },

    {
      id: "project_period",
      name: "project_period",
      label: "Job Period",
      type: "date",
      noInput: true,
      // value: formData?.project_start_date,
      disabled: true,
      // hide: formData?.category_id !== "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      // noLabel: true,
      colspan: 2,
    },

    {
      id: "project_start_date",
      name: "project_start_date",
      label: "Period Start Date",
      type: "date",
      placeholder: "Job Start Date",
      value: formData?.project_start_date,
      disabled: true,
      noLabel: true,
      // hide: formData?.category_id !== "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      // noLabel: true,
      colspan: 1,
    },
    {
      id: "project_end_date",
      name: "project_end_date",
      label: "Period End Date",
      type: "date",
      placeholder: "Job End Date",
      value: formData?.project_end_date,
      disabled: true,
      noLabel: true,
      // hide: formData?.category_id !== "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      // noLabel: true,
      colspan: 1,
    },
    // {
    //   id: "due_date",
    //   name: "due_date",
    //   label: "Due Date",
    //   type: "dateTimeCombo",
    //   value: formData?.due_date,
    //   hide: formData?.category_id === "project",
    //   colspan: "2",
    //   useFetchHook: useLazyGetProjectTaskEnumQuery,
    //   // noLabel: true,
    // },

    // {
    //   id: "service_id",
    //   name: "service_id",
    //   label: "Link To Service",
    //   type: "select",
    //   value: formData?.service_id,
    //   displayValueKey: "service_name",
    //   // hide: formData?.category_id !== "project",
    //   colspan: "2",
    //   noKeyboardNavigation: true,
    //   childrenKey: "sub_services",
    //   apiCall: function () {
    //     return getServiceList();
    //   },
    //   dynamicOptions: serviceList?.data?.map((eachItem) => ({
    //     label: eachItem?.name,
    //     value: eachItem?.id,
    //     children: eachItem?.sub_services?.map((eachTask) => ({
    //       label: eachTask?.name,
    //       value: eachTask?.id,
    //     })),
    //   })),
    //   isLoading: serviceListLoading,
    //   isMandatory: formData?.category_id === "project",
    //   useFetchHook: useLazyGetProjectTaskEnumQuery,
    // },
  ];

  const projectFields2 = [
    {
      id: "service_id",
      name: "service_id",
      label: "Link To Service",
      type: "select",
      value: formData?.service_id,
      displayValueKey: "service_name",

      colspan: "2",
      noKeyboardNavigation: true,
      childrenKey: "sub_services",
      apiCall: function () {
        return getServiceList();
      },
      dynamicOptions: serviceList?.data?.map((eachItem) => ({
        label: eachItem?.name,
        value: eachItem?.id,
        children: eachItem?.sub_services?.map((eachTask) => ({
          label: eachTask?.name,
          value: eachTask?.id,
        })),
      })),
      isLoading: serviceListLoading,
      isMandatory: formData?.category_id === "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },

    {
      id: "return_type",
      name: "return_type",
      label: "Return Type",
      type: "select",
      value: formData?.return_type,
      // dynamicOptions: projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
      // isLoading: projectFieldListLoading,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "job",
        field: "return_type",
      },
      // apiCall: function() {
      //   return getFieldValue("return_type","job");
      // },
      hide: serviceList?.data
        ? serviceList.data.find((eachItem) => eachItem?.id === formData?.service_id)?.name !== "Tax"
        : formData?.service_name !== "Tax",
    },
    {
      id: "complexity",
      name: "complexity",
      label: "Complexity",
      type: "select",
      value: formData?.complexity,
      hide: serviceList?.data
        ? serviceList.data.find((eachItem) => eachItem?.id === formData?.service_id)?.name !== "Tax"
        : formData?.service_name !== "Tax",
      // dynamicOptions:projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
      isLoading: projectFieldListLoading,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "job",
        field: "complexity",
      },
      // apiCall: function() {
      //   return getFieldValue("complexity","job");
      // },
    },

    {
      id: "target_delivery_date",
      name: "target_delivery_date",
      label: "Target delivery date",
      type: "date",
      value: formData?.target_delivery_date,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      disabled: true,
    },

    {
      id: "budgeted_hours",
      name: "budgeted_hours",
      label: "Budgeted hours",
      type: "hours",
      value: formData?.budgeted_hours,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      disabled: true,
    },
  ];

  const projectFields3 = [
    {
      id: "subject",
      name: "subject",
      label: "Task Name",
      type: "text",
      value: "subject",
      disabled: true,
      col_span: "2",
      isMandatory: true,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    // {
    //   id: "service_id",
    //   name: "service_id",
    //   label: "Link To Service",
    //   type: "select",
    //   value: formData?.service_id,
    //   displayValueKey: "service_name",
    //   hide: ["project", "deal"].includes(formData?.category_id),
    //   colspan: "2",
    //   noKeyboardNavigation: true,
    //   childrenKey: "sub_services",
    //   apiCall: function () {
    //     return getServiceList();
    //   },

    //   dynamicOptions: serviceList?.data?.map((eachItem) => ({
    //     label: eachItem?.name,
    //     value: eachItem?.id,
    //     children: eachItem?.sub_services?.map((eachTask) => ({
    //       label: eachTask?.name,
    //       value: eachTask?.id,
    //     })),
    //   })),
    //   isLoading: serviceListLoading,
    //   isMandatory: formData?.category_id === "project",
    //   useFetchHook: useLazyGetProjectTaskEnumQuery,
    // },
    {
      id: "priority",
      name: "priority",
      label: "Priority",
      type: "radio",
      value: "priority",
      defaultOptions: customerCommonData?.data?.priority?.map((item) => ({ label: item.value, value: item.value })),
      colspan: "2",
      useFetchHook: useLazyGetProjectTaskEnumQuery,

      //   // hide: formData?.category_id === "project",
    },

    {
      id: "job_period",
      name: "job_period",
      label: "Period",
      type: "dateTimeCombo",
      value: formData?.job_period,
      disabled: true,
      // hide: formData?.category_id !== "project",
      col_span: "2",
      noLabel: true,
      isMandatory: true,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    // {
    //   id: "due_time",
    //   name: "due_time",
    //   label: "",
    //   type: "",
    //   value: formData?.due_time,
    //   hide: formData?.category_id !== "project",
    //   useFetchHook: useLazyGetProjectTaskEnumQuery,
    //   // noLabel: true,
    // },

    {
      id: "status",
      name: "status",
      label: "Status",
      type: "select",
      value: "status",
      noDisabled: true,
      defaultOptions: customerCommonData?.data?.status?.map((item) => ({ label: item.value, value: item.value })),
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      colspan: "2",
    },
    // {
    //   id: "tag",
    //   name: "tag",
    //   label: "Tags",
    //   type: "tags",
    //   value: formData?.tag,
    //   dynamicOptions: TaskTagsList?.map((eachItem) => ({
    //     ...eachItem,
    //     label: eachItem.tag_name,
    //     value: eachItem.id,
    //     color_code: eachItem?.colour_code,
    //     bg_code: eachItem?.bg_code,
    //     default_label: eachItem?.default_tag_name,
    //   })),
    //   // colspan: "2",
    //   // hide: formData?.tag,
    //   // isMandatory: true,
    //   updateTags: handleUpdateTags,
    //   clickTrigger: () => fetchTaskTags("", false),
    //   useFetchHook: useLazyGetProjectTaskEnumQuery,
    // },

    // {
    //   id: "task_pod",
    //   name: "task_pod",
    //   label: `Link to ${getSentenceCase(formData?.category_id)} Pod`,
    //   type: "select",
    //   value: formData?.task_pod,
    //   addButton: true,
    //   addButtonLabel: `+ Add ${["project", "deal"].includes(formData?.category_id?.toLowerCase()) ? `${formData?.category_id} Pod` : "Taskpod"} `,
    //   defaultOptions: newTaskpodsAll?.data?.pods?.map((item) => ({ label: item.pod_name, value: item.pod_name })),
    //   addButtonAction: handleAddTaskPod,
    //   // colspan: formData?.category_id?.toLowerCase() === "project" ? "2" : "1",
    //   useFetchHook: useLazyGetProjectTaskEnumQuery,
    //   // colspan: formData?.category_id === "deal"?"2":"1",
    // },
    {
      id: "assigned_to",
      name: "assigned_to",
      label: "Assigned To",
      type: "assigned_to",
      value: formData?.assigned_to,
      colspan: "2",
      isSearchBarOpen: isSearchBarOpen,
      taskassignedtoref: taskassignedtoref,
      handleMouseEnter: handleMouseEnter,
      handleMouseLeave: handleMouseLeave,
      handleCheck: handleCheck,
      personTableData: personTableData,
      handleSelectPerson: handleSelectPerson,
      handleRemovePerson: handleRemovePerson,
      searchTerm: searchTerm,
      isEditTask: isEditTask,

      // hide:
      //   headerField &&
      //   Object?.entries(headerField)?.some(([sectionLabel]) => sectionLabel === "Attachment") === true
      //     ? false
      //     : true,
    },
    // {
    //   id: "attachment",
    //   name: "attachment",
    //   label: "Attachment",
    //   type: "file",
    //   value: formData?.attachment,
    //   colspan: "2",
    //   // hide:
    //   //   headerField &&
    //   //   Object?.entries(headerField)?.some(([sectionLabel]) => sectionLabel === "Attachment") === true
    //   //     ? false
    //   //     : true,
    // },
  ];

  const projectFields4 = [
    {
      id: "billing_status",
      name: "billing_status",
      label: "Billing Status",
      type: "select",
      value: formData?.billing_status,
      noDisabled: true,
      formSaveKey: "billing_details",
      isLoading: projectFieldListLoading,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "billing",
        field: "billing_status",
      },
    },

    {
      id: "invoice_number",
      name: "invoice_number",
      label: "Invoice Number",
      type: "text",
      value: formData?.invoice_number,
      noDisabled: true,
      formSaveKey: "billing_details",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    {
      id: "billing_date",
      name: "billing_date",
      label: "Invoice Date",
      type: "date",
      value: formData?.billing_date,
      noDisabled: true,
      formSaveKey: "billing_details",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    {
      id: "payment_status",
      name: "payment_status",
      label: "Payment Status",
      type: "select",
      value: formData?.payment_status,
      noDisabled: true,
      formSaveKey: "billing_details",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "billing",
        field: "payment_status",
      },
    },
    {
      id: "target_delivery_date",
      name: "target_delivery_date",
      label: "Target Delivery Date",
      type: "date",
      value: formData?.target_delivery_date,
      noDisabled: true,
      formSaveKey: "billing_details",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    {
      id: "time_tracked",
      name: "time_tracked",
      label: "Time Booked",
      type: "time",
      value: formData?.time_tracked,
      noDisabled: true,
      formSaveKey: "billing_details",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
  ];

  const fetchAndSetFieldOptions = async (field) => {
    try {
      const response = await FetchFieldDropDownValues({
        FieldName: field?.value,
      }).unwrap();

      if (response?.data?.length) {
        setDropdownOptionsMap((prev) => ({
          ...prev,
          [field.id]: response?.data?.map((option) => ({
            label: option?.value?.value,
            value: option?.value?.value,
            color: option?.value?.color,
          })),
        }));
      }
    } catch (err) {
      setDropdownOptionsMap((prev) => ({
        ...prev,
        [field.id]: [],
      }));
    }
  };

  const handleRemoveProjectFields = () => {
    setFormData((prevFormData) => {
      const updatedFormData = structuredClone(prevFormData);
      projectFields1?.forEach((key) => delete updatedFormData[key]);
      projectFields2?.forEach((key) => delete updatedFormData[key]);
      return updatedFormData;
    });
  };
  const sectionRefs = useRef({});

  const checkAndPerformOperation = (key) => {
    switch (key) {
      case "all_discard_and_close":
        setCategory({ name: "category_id", value: formData?.category_id });
        setFormData({});
        setOpenConfirmationDialog(false);
        closePopup();
        break;

      case "close_only_confirmation_dialog":
        setCategory({ name: "category_id", value: formData?.category_id });
        setOpenConfirmationDialog(false);

        break;

      case "discard_subtask_and_switch_to_non-task":
        handleRemoveSubtasks();
        handleCategoryUpdate();
        setOpenConfirmationDialog(false);
        setShowSubtaskForm("");

        break;

      case "discard_project_and_switch_to_other_task":
        handleRemoveSubtasks();
        handleRemoveChecklist();
        handleCategoryUpdate();
        handleRemoveProjectFields();
        setOpenConfirmationDialog(false);
        setShowSubtaskForm("");
        break;

      default:
        break;
    }
  };

  const handleLinkClick = () => {
    setIsLinkOpen((prev) => !prev);
  };

  //its for gerenal field
  const getProjectGerneralFields = ({ projectFields }) => (
    <>
      {projectFields
        ?.filter((item) => !item?.hide)
        .map((eachField) => (
          <div
            className={`basis-5/5 mb-1 col-span-${eachField.colspan ?? "1"}`}
            style={{ margin: eachField?.noInput && "0px" }}
          >
            {!eachField?.noLabel && (
              <LabelComponent
                labelText={eachField?.label}
                htmlFor={eachField?.label}
                size="small"
                className="font-600 text-535252"
                isMandatory={eachField?.isMandatory}
                isFormDisabled={isFormDisabled}
              />
            )}
            {!eachField?.noInput && (
              <div className="flex items-center">
                {eachField?.type === "dateTimeCombo" ? (
                  <DateTimeRecurence
                    innerLabel={"Task Due Date"}
                    name={eachField?.name}
                    showEndDate={showEndDate}
                    showTime={showTime}
                    handleCheckboxChange={handleCheckboxChange}
                    openPopup={openPopup}
                    isPopupOpen={isPopupOpen}
                    isFormDisabled={isFormDisabled}
                    formData={formData}
                    setIsPopupOpen={setIsPopupOpen}
                    ActivateRecur={ActivateRecur}
                    closePopupRecur={closePopupRecur}
                    taskid={taskid}
                    setStartDate={setStartDate}
                    startDate={startDate}
                    setEndDate={setEndDate}
                    endDate={endDate}
                    StartTimeElement={StartTimeElement}
                    Fragment={Fragment}
                    EndTimeElement={EndTimeElement}
                    setFormData={setFormData}
                    StartDateChange={StartDateChange}
                    isMandatory={eachField?.isMandatory}
                    drawerRef={drawerRef}
                  />
                ) : (
                  <FieldElements
                    {...eachField}
                    id={eachField?.id}
                    name={eachField?.name}
                    label={eachField?.label}
                    placeholder={eachField?.placeholder}
                    value={eachField?.value}
                    displayValueKey={eachField?.displayValueKey}
                    onChange={handleGerneralInputChange}
                    disabled={eachField?.disabled}
                    isFormDisabled={isFormDisabled}
                    // defaultOptions={selectionList}
                    type={eachField?.type}
                    noKeyboardNavigation={eachField?.noKeyboardNavigation}
                    childrenKey={eachField?.childrenKey}
                    formData={formData}
                    taskid={taskid}
                    defaultOptions={eachField?.defaultOptions}
                    dynamicOptions={eachField?.dynamicOptions}
                    apiCall={eachField?.apiCall}
                    addButton={eachField?.addButton}
                    addButtonLabel={eachField?.addButtonLabel}
                    addButtonAction={eachField?.addButtonAction}
                    isLoading={eachField?.isLoading}
                    useFetchHook={eachField?.useFetchHook}
                    hookPayload={eachField?.hookPayload}
                    noDisabled={eachField?.noDisabled}
                    // displayName={eachField?.displayName}
                  />
                )}
                {/* {getFieldElements(
           { id:eachField?.id,name:eachField?.name,label:eachField?.label,onChange:handleInputChange,disabled:eachField?.disabled,isFormDisabled:eachField?.isFormDisabled,selectionList,type:eachField?.type}
         )} */}
              </div>
            )}
          </div>
        ))}
    </>
  );

  // its for DYNAMIC FIELDS
  const GetProjectFields = ({ projectFields }) => (
    <>
      {projectFields
        ?.filter((item) => !item?.hide)
        .map((eachField, idx) => (
          <>
            <div
              key={eachField?.id || eachField?.label || idx}
              className={`basis-1/2 mb-1 col-span-${eachField?.col_span ?? "1"}`} // paylaod response as col_span
              style={{ margin: eachField?.noInput && "0px" }}
            >
              {!eachField?.noLabel && (
                <>
                  <LabelComponent
                    labelText={eachField?.label}
                    htmlFor={eachField?.label}
                    size="small"
                    className="font-600 text-535252"
                    isMandatory={eachField?.isMandatory}
                    isFormDisabled={isFormDisabled}
                  />
                </>
              )}
              {!eachField?.noInput && (
                <div className="flex items-center">
                  {eachField?.type === "dateTimeCombo" ? ( // dateTimeCombo for reccurrence
                    <DateTimeRecurence
                      innerLabel={"Start Date"}
                      name={eachField?.name}
                      showEndDate={showEndDate}
                      showTime={showTime}
                      handleCheckboxChange={handleCheckboxChange}
                      openPopup={openPopup}
                      isPopupOpen={isPopupOpen}
                      isFormDisabled={isFormDisabled}
                      formData={formData}
                      setIsPopupOpen={setIsPopupOpen}
                      ActivateRecur={ActivateRecur}
                      closePopupRecur={closePopupRecur}
                      taskid={taskid}
                      setStartDate={setStartDate}
                      startDate={startDate}
                      setEndDate={setEndDate}
                      endDate={endDate}
                      StartTimeElement={StartTimeElement}
                      Fragment={Fragment}
                      EndTimeElement={EndTimeElement}
                      setFormData={setFormData}
                      StartDateChange={StartDateChange}
                      isMandatory={eachField?.isMandatory}
                      drawerRef={drawerRef}
                    />
                  ) : (
                    // <></>
                    <FieldElements
                      {...eachField}
                      id={eachField?.value}
                      name={eachField?.value}
                      label={eachField?.label}
                      placeholder={eachField?.placeholder}
                      value={formData && formData[eachField?.value]}
                      displayValueKey={eachField?.displayValueKey}
                      onChange={(e) =>
                        handleInputChange({
                          target: {
                            label: eachField?.label,
                            value: e?.target?.value,
                            name: eachField?.value,
                          },
                        })
                      }
                      disabled={eachField?.disabled}
                      isFormDisabled={isFormDisabled}
                      type={eachField?.type}
                      noKeyboardNavigation={eachField?.noKeyboardNavigation}
                      childrenKey={eachField?.childrenKey}
                      formData={formData}
                      taskid={taskid}
                      defaultOptions={eachField?.defaultOptions}
                      apiCall={eachField?.apiCall}
                      apiCallParam={eachField}
                      dynamicOptions={
                        dropdownOptionsMap?.[eachField?.id]
                          ? dropdownOptionsMap?.[eachField?.id]?.map((option) => ({
                              label: option?.label,
                              value: option?.value,
                              color_code: option?.color,
                            }))
                          : []
                      }
                      addButton={eachField?.addButton}
                      addButtonLabel={eachField?.addButtonLabel}
                      addButtonAction={eachField?.addButtonAction}
                      isLoading={eachField?.isLoading}
                      useFetchHook={eachField?.useFetchHook}
                      hookPayload={eachField?.hookPayload}
                      noDisabled={eachField?.noDisabled}
                    />
                  )}
                  {/* {getFieldElements(
         { id:eachField?.id,name:eachField?.name,label:eachField?.label,onChange:handleInputChange,disabled:eachField?.disabled,isFormDisabled:eachField?.isFormDisabled,selectionList,type:eachField?.type}
       )} */}
                </div>
              )}
            </div>
          </>
        ))}
    </>
  );

  const handleFunnelClose = () => {
    setFunnelClose((prev) => !prev);
  };

  return (
    <>
      <CustomDrawer
        open={true}
        onClose={closePopup}
        variant="temporary"
        width="35vw"
        showSubDrawer={
          showNotification ||
          isLinkOpen ||
          showSubtaskForm === "task" ||
          showSubtaskForm === "project" ||
          isPopupOpen ||
          (formData?.funnel_id && funnelClose)
        }
      >
        <div className="flex flex-col h-full w-full " ref={drawerRef}>
          {/* link and sharing options pending,  */}
          <div className="w-full bg-white flex items-center justify-between px-3 py-2 border-b-2">
            <div className="flex items-center text-lg font-medium text-[#131313CC] gap-1">Add {viewFor}</div>

            <div className="flex items-center justify-center gap-2">
              <div className="flex items-center justify-center">
                {/* {isEditTask && (
                  <button
                    className="mx-2"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsLinkOpen(false);
                      handleNotification();
                      setShowSubtaskForm(false);
                    }}
                  >
                    {<MenuBar />}
                  </button>
                )} */}

                <button
                  onClick={() => {
                    handleLinkClick();
                    setShowNotification(false);
                  }}
                  className="mx-2"
                >
                  <Share />
                </button>
              </div>
              <button
                onClick={closePopup}
                type="button"
                className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                data-modal-hide="assets-modal"
              >
                <CloseModalImg className="w-3 h-3" />
                <span className="sr-only">Close modal</span>
              </button>
            </div>
          </div>

          <form
            id={tableDetail?.tableidclass}
            // onSubmit={handleSubmitTask}
            className={`w-full flex flex-col justify-start flex-1 grow min-h-0 relative ${tableDetail?.tableidclass}`}
          >
            {/* ger. info */}
            <div className=" border-[#BECBD3] p-3 py-2">
              {getProjectGerneralFields({
                projectFields: projectFields0,
              })}
            </div>

            {/* dynamic header/fields */}
            <div className="border-[#BECBD3] px-3 min-h-0 grow overflow-y-auto scrollbar-hidden">
              {/* Fixed Task Information */}
              <div className="flex flex-col min-h-0 grow">
                {false && (
                  <div
                    className="flex items-center justify-start gap-x-2 w-full cursor-pointer"
                    ref={(el) => {
                      if (el) sectionRefs.current["Task Information"] = el;
                    }}
                    onClick={() => {
                      sectionRefs.current["Task Information"]?.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }}
                  >
                    <div className="text-base font-semibold text-[#1D4469] mb-2 whitespace-nowrap">
                      Task Information
                    </div>
                    <div className="flex-1 h-1 bg-[#1d4469dc] rounded-lg mb-2"></div>
                  </div>
                )}

                <div className="grid grid-cols-2  gap-x-2 min-h-0 grow">
                  {GetProjectFields({ projectFields: projectFields3 })}

                  {/* <SelectComponent
                    options={personTableData?.data?.map((option) => ({
                     value: option.id,
                     label: option.name,
                      subLabel: option.email,
                              }))}
                              personList
                              multiSelect
                              onChange={(e) => handleInsert(e)}
                              name="owner"
                              value={personTableData?.data
                                ?.filter((option) => option?.email === formData?.owner)
                                .map((option) => ({
                                  value: option.id,
                                  label: option.name,
                                  subLabel: option.email,
                                }))}
                              // size="small"
                              showSearch
                              boxWidth
                            /> */}

                  {/* Description */}
                  <div className="col-span-2">
                    <div className="basis-5/5 mb-3 col-span-3">
                      <LabelComponent
                        labelText="Description"
                        htmlFor="description"
                        size="small"
                        isFormDisabled={isFormDisabled}
                        className="font-600"
                      />
                      <textarea
                        id="description"
                        name="description"
                        placeholder="Type Something..."
                        value={formData?.description}
                        onChange={handleInputChange}
                        className={`rounded border ${
                          isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"
                        } focus:outline-hidden focus:ring-0 focus:border-1D5D9B text-xs block w-full h-[80px] resize-none`}
                      />
                    </div>
                  </div>

                  {/* Remarks */}
                  {showRemark && (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 col-span-2">
                      <div className="basis-5/5 mb-3 px-6 col-span-3">
                        <label htmlFor="remarks" className="font-medium block mb-2 text-sm text-434852">
                          Remarks
                        </label>
                        <textarea
                          id="remarks"
                          name="remarks"
                          placeholder="Type Something..."
                          value={formData?.remarks}
                          onChange={handleInputChange}
                          className="bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-C4D3E2 focus:shadow-10 text-gray-900 text-sm block w-full h-[40px] resize-none"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Dynamic Sections */}
              {headerField &&
                Object.entries(headerField)
                  .filter(
                    ([sectionLabel, fields]) =>
                      ![
                        "Project Information",
                        "Service Information",
                        "Task Information",
                        "Funnel Information",
                      ].includes(sectionLabel)
                  )
                  .map(([sectionLabel, sectionData], idx) => (
                    <div key={sectionLabel + idx}>
                      {GetProjectFields({
                        projectFields: sectionData?.fields?.filter((field) => field?.is_visible === 1),
                      })}
                    </div>
                  ))}
            </div>

            <div className="sticky bottom-0 self-end border-y w-full flex justify-end border-BECBD3 p-3">
              <button
                onClick={closePopup}
                type="button"
                className="w-28 text-383838 bg-F4F4F4 border border-[#D2DAE1] hover:bg-eeeeee cancel-btn focus:ring-4 focus:ring-blue-300 font-semibold px-5 py-1 text-center rounded-[5px]"
              >
                Cancel
              </button>
              <button
                type="button"
                className={`w-28 text-white save-btn border border-[#D2DAE1]  font-semibold  py-1 px-5 ms-3 rounded-[5px] 
                              bg-[#5489FF]  hover:bg-[#004EFF] border-[#004EFF`}
                //temporarily disabled the customer_name field, wasn't able to figure it out
                // disabled={formData.customer_id === "" || formData.customer_name === ""}
                // disabled={formData.customer_id === ""}
              >
                Save
              </button>
            </div>
          </form>
        </div>

        {showNotification && (
          <CustomerEditTaskActivity
            activityid={taskid?.id}
            // showNotification={showNotification}
            // handleNotification={handleNotification}
            // cross={cross}
            open={showNotification}
            onClose={handleNotification}
            type="Task"
            // parallelDrawer
            subDrawer
          />
        )}
        {isLinkOpen && (
          <LinkedDrawer
            open={isLinkOpen}
            data={initialFormData}
            onClose={() => {
              setIsLinkOpen(false);
              setShowNotification(false);
            }}
            parentId={taskid}
            parentType="TASK"
            selectedCustomer
            subDrawer
          />
        )}

        {showSubtaskForm === "task" && (
          <SubTaskDrawer
            isEditTask={isEditTask}
            formData={formData}
            handleDeleteSubtask={handleDeleteSubtask}
            customerTaskCategory={customerCommonData}
            startDate={startDate}
            endDate={endDate}
            personTableData={personTableData}
            handleSubTaskPerson={handleSubTaskPerson}
            handleCheck={handleCheck}
            searchTerm={searchTerm}
            subTaskContainerRef={subTaskContainerRef}
            handleSubtaskChange={handleSubtaskChange}
            handleSubtaskCheckboxChange={handleSubtaskCheckboxChange}
            isFormDisabled={isFormDisabled}
            handleMouseEnter={handleMouseEnter}
            handleMouseLeave={handleMouseLeave}
            isSearchBarOpen={isSearchBarOpen}
            setIsSearchBarOpen={setIsSearchBarOpen}
            dropdownCoord={dropdownCoord}
            taskassignedtoref={taskassignedtoref}
            subTaskSelected={subTaskSelected}
            setSubtaskSelected={setSubtaskSelected}
            fetchPersonData={fetchPersonData}
            subTaskForm={subTaskForm}
            setSubTaskForm={setSubTaskForm}
            initialSubTaskForm={initialSubTaskForm}
            subDrawer
            open={showSubtaskForm === "task"}
            addSubtask={addSubtask}
            addChecklist={addChecklist}
            setFormData={setFormData}
            onClose={() => {
              setShowSubtaskForm(false);
            }}
          />
        )}

        {showSubtaskForm === "project" && (
          <ChecklistDrawer
            isEditTask={isEditTask}
            formData={formData}
            handleDeleteSubtask={handleDeleteSubtask}
            customerTaskCategory={customerCommonData}
            personTableData={personTableData}
            handleSubTaskPerson={handleSubTaskPerson}
            handleCheck={handleCheck}
            searchTerm={searchTerm}
            subTaskContainerRef={subTaskContainerRef}
            handleSubtaskChange={handleSubtaskChange}
            handleSubtaskCheckboxChange={handleSubtaskCheckboxChange}
            isFormDisabled={isFormDisabled}
            handleMouseEnter={handleMouseEnter}
            handleMouseLeave={handleMouseLeave}
            isSearchBarOpen={isSearchBarOpen}
            setIsSearchBarOpen={setIsSearchBarOpen}
            dropdownCoord={dropdownCoord}
            taskassignedtoref={taskassignedtoref}
            subTaskSelected={subTaskSelected}
            setSubtaskSelected={setSubtaskSelected}
            fetchPersonData={fetchPersonData}
            checklistForm={checklistForm}
            setChecklistForm={setChecklistForm}
            initialChecklistForm={initialChecklistForm}
            useLazyGetProjectTaskEnumQuery={useLazyGetProjectTaskEnumQuery}
            projectFieldListLoading={projectFieldListLoading}
            handleChecklistChange={handleChecklistChange}
            subDrawer
            open={showSubtaskForm === "project"}
            onClose={() => {
              setShowSubtaskForm(false);
            }}
            addSubtask={addSubtask}
            addChecklist={addChecklist}
            setFormData={setFormData}
          />
        )}

        {openConfirmationDialog && (
          <ConfirmationDialogBox
            open={openConfirmationDialog}
            // open={hasFormChanged && categoryChange?.name?.toLowerCase() === "category_id"}
            onClose={() => {
              checkAndPerformOperation("close_only_confirmation_dialog");
            }}
            onConfirm={() => {
              checkAndPerformOperation(openConfirmationDialog);
            }}
          >
            <div>
              {formData?.sub_tasks?.some((subtask) => subtask.subject !== "")
                ? "Changing the task category will remove all associated sub-tasks."
                : ""}
              {formData?.sub_tasks?.some((subtask) => subtask.subject !== "") && <br />}
              Do you want to discard the changes you have done.?
            </div>
          </ConfirmationDialogBox>
        )}
        {openAddNewPodModal && (
          <div>
            <AddNewPodModal
              open={openAddNewPodModal}
              onClose={() => setOpenAddNewPodModal(false)}
              taskid={taskid?.id}
              category_id={formData?.category_id}
              customerId={taskid?.customer_id || formData?.customer_id}
              refetchPods={refetchAllTaskpods}
            />
          </div>
        )}
        {openAddProject && (
          <AddViewProjectDrawer
            open={openAddProject}
            setOpen={setOpenAddProject}
            onClose={() => setOpenAddProject(false)}
            customerTaskPodAllCustomer={customerTaskPodAllCustomer}
            setJobFormData={setFormData}
            projectId={formData?.project_id}
            getFieldValue={getFieldValue}
            projectFieldList={projectFieldList}
            fetchPersonInTable={fetchPersonData}
            personTableData={personTableData}
            selectedCustomer={selectedCustomer || { id: formData?.customer_id }}
            refetchGetAllTasks={refetchGetAllTasks}
          />
        )}

        {/* funnel subDrawer */}
        {(fullHeaderObject && fullHeaderObject?.funnel_type ? true : false) && funnelClose && (
          <SubDrawerRenderer
            subDrawer
            open={(fullHeaderObject && fullHeaderObject?.funnel_type ? true : false) && funnelClose}
            headerText="Stages"
            onClose={() => handleFunnelClose()}
          >
            <FunnelSubDrawer
              taskid={taskid}
              FunnelId={fullHeaderObject?.funnel_type}
              activeFunnel={formData?.funnel_id}
              funnelStages={funnelStages}
              setFunnelStages={setFunnelStages}
              Funnel_type={fullHeaderObject && fullHeaderObject?.funnel_type}
              coloredStyle
            />
          </SubDrawerRenderer>
        )}
      </CustomDrawer>
    </>
  );
};
export default TaskExtendView;
